import type { Achievement } from "../achievement.types";

export const qedAchievement: Achievement = {
  id: "qed",
  name: "Q.E.D.",
  description: "Finished the guided walkthrough.",
  icon: "school",
  check: (gameReport, gameStatus) => {
    if (gameStatus !== "won" || !gameReport) {
      return false;
    }
    // Awarded only for finishing the tutorial game (reaching the target).
    return gameReport.isTutorial === true;
  },
};
